// File: src/components/ui/badge.tsx
import React from 'react';

export function Badge({ 
  children, 
  variant = 'default',
  className = ''
}: { 
  children: React.ReactNode; 
  variant?: 'default' | 'success' | 'destructive' | 'secondary' | 'outline';
  className?: string;
}) {
  const base = 'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset';
  const variants: Record<string, string> = {
    default: 'bg-[var(--brand-surface-muted)] text-[var(--brand-text-secondary)] ring-[var(--brand-border)]',
    success: 'bg-[var(--brand-status-success-bg)] text-[var(--brand-status-success)] ring-[color-mix(in oklab, var(--brand-status-success) 35%, transparent)]',
    destructive: 'bg-[var(--brand-status-danger-bg)] text-[var(--brand-status-danger)] ring-[color-mix(in oklab, var(--brand-status-danger) 35%, transparent)]',
    secondary: 'bg-[var(--brand-accent-primary-soft)] text-[var(--brand-accent-primary)] ring-[color-mix(in oklab, var(--brand-accent-primary) 35%, transparent)]',
    outline: 'text-[var(--brand-text-secondary)] ring-[var(--brand-border-strong)] bg-transparent',
  };

  return <span className={`${base} ${variants[variant] || variants.default} ${className}`}>{children}</span>;
}
